import { Box } from '@chakra-ui/react';

/**
 * Полоска-ручка окна на десктопе: «эту коробку можно тянуть». На телефоне её нет (01.10.2026):
 * раскрытый виджет тянется за любое место, и полоска делала его похожим на шторку.
 */
export const RoomGrip = () => (
  <Box w="32px" h="3px" borderRadius="full" bg="fg.subtle" aria-hidden="true" />
);
